// extracted by mini-css-extract-plugin
export default {"wrapper":"chat_with_icon-module___wrapper___e50f9f39"};